/*
 * @Description: 路由
 * @Date: 2025-05-22 18:45:35
 */
export const route = [
  {
    path: '/main/receive-task-list',
    name: 'receive-task-list',
    meta: {
      title: '接收任务'
    },
    component: () => import('../views/receive-task-list/index')
  },
  {
    path: '/main/receive-task-detail',
    name: 'receive-task-detail',
    meta: {
      title: '查看明细',
      parentPath: '/main/receive-task-list'
    },
    component: () => import('../views/receive-task-detail.vue')
  }
];
